module.exports = __webpack_public_path__ + "img/icon-close.6fb37441.png";